import React, { useState, useEffect, useRef } from "react";
import {
  collection,
  getDocs,
  query,
  orderBy,
  doc,
  getDoc,
  setDoc,
  arrayUnion,
  updateDoc,
} from "firebase/firestore";
import { db } from "../../../firebase";
import "../../../styles/Part2.css";
import { whoQuestions } from "../../../data/part2/who";
import { whereQuestions } from "../../../data/part2/where";
import { whichQuestions } from "../../../data/part2/which";
import { whyQuestions } from "../../../data/part2/why";
import { whatQuestions } from "../../../data/part2/what";
import { whenQuestions } from "../../../data/part2/when";
import { howQuestions } from "../../../data/part2/how";
import { auxiliaryQuestions } from "../../../data/part2/auxiliary";
import { tagQuestions } from "../../../data/part2/tag";
import { nounClauseQuestions } from "../../../data/part2/nounClause";
import { beVerbQuestions } from "../../../data/part2/beVerb";
import { makeChoiceQuestions } from "../../../data/part2/makeChoice";
import { negativeQuestions } from "../../../data/part2/negative";
import { stateQuestions } from "../../../data/part2/state";
import { abilityPossibilityAuxiliaryQuestions } from "../../../data/part2/abilityPossibilityAuxiliary";
import Part2VocabModal from "./Part2VocabModal";
import Modal from "react-modal";
import { useAuth } from "../../../contexts/AuthContext";
import { freeContent } from "../../../utils/freeContent";

const Part2_1 = ({ isActive }) => {
  const [selectedCategory, setSelectedCategory] = useState("");
  const [showQuestions, setShowQuestions] = useState(false);
  const [questions, setQuestions] = useState([]);
  const [currentQuestionIndex, setCurrentQuestionIndex] = useState(0);
  const [timeLeft, setTimeLeft] = useState(5);
  const [isTimerRunning, setIsTimerRunning] = useState(false);
  const [selectedAnswers, setSelectedAnswers] = useState([]);
  const [loading, setLoading] = useState(true);
  const [isStarted, setIsStarted] = useState(false);
  const [studyMode, setStudyMode] = useState("both");
  const [showResult, setShowResult] = useState(false);
  const [isPlaying, setIsPlaying] = useState(false);
  const audioRef = useRef(null);
  const [subCategory, setSubCategory] = useState("");
  const [accentType, setAccentType] = useState("us"); // "us" 또는 "uk"
  const [playbackRate, setPlaybackRate] = useState(1.0); // 재생 속도 상태 추가
  const [showVocabModal, setShowVocabModal] = useState(false);
  const [isStudyModeModalOpen, setIsStudyModeModalOpen] = useState(false);
  const [showNoWrongQuestionsModal, setShowNoWrongQuestionsModal] =
    useState(false);
  const { currentUser } = useAuth();
  const [isChecking, setIsChecking] = useState(false); // 답 확인 중 상태 추가
  const [selectedSubCategory, setSelectedSubCategory] = useState("");
  const [completedCategories, setCompletedCategories] = useState({});
  const [isShortMode, setIsShortMode] = useState(false); // 상태 추가
  const [solvedQuestions, setSolvedQuestions] = useState(new Set());
  const [lastQuestionIndices, setLastQuestionIndices] = useState({});
  const [showVideoModal, setShowVideoModal] = useState(false);

  const subCategories = {
    auxiliary: {
      title: "요청 및 가능성여부 의문문",
      description: "요청하거나 가능여부를    묻는 모든 질문 유형",
      examples: [
        "Can you help me?",
        "Will it rain tomorrow?",
        "Should I wait here?",
      ],
    },
    where: {
      title: "장소 / 시간 / 인물 / 이유 의문문",
      description: "어디서, 언제, 누구, 이유만  묻는 질문",
      examples: [
        "Where is the meeting?",
        "Where should I put this?",
        "Where did you go?",
      ],
    },
    which: {
      title: "선택 의문문",
      description: "선택을 묻는 의문문",
      examples: [
        "Which color do you prefer?",
        "Which way should we go?",
        "Which option is better?",
      ],
    },
    why: {
      title: "제안 의문문",
      description: "제안을 하는 모든 의문문",
      examples: [
        "Why are you late?",
        "Why did this happen?",
        "Why not try again?",
      ],
    },
    beVerb: {
      title: "Yes or No 확인을 할 때묻는 의문문 ",
      description: "Be동사, 부정, 부가의문문",
      examples: ["Is she a doctor?", "Are you ready?", "Was it difficult?"],
    },
    how: {
      title: "HOW 의문문",
      description: "HOW로 시작하는 의문문",
      examples: [
        "How did you do that?",
        "How are you feeling?",
        "How does this work?",
      ],
    },
    what: {
      title: "What 의문문",
      description: "다 커버하는 what 유형 질문",
      examples: ["What is this?", "What happened?", "What do you need?"],
    },
    state: {
      title: "물음표 없는 의문문",
      description: "질문은 아닌데 답해야 하는 것들",
      examples: ["What's going on?", "How's everything?", "What's the matter?"],
    },
    abilityPossibilityAuxiliary: {
      title: "조동사 의문문",
      description: "능력과 가능성을 묻는 조동사 의문문",
      examples: [
        "Can you finish the project by Friday?",
        "Is it possible to schedule a meeting for tomorrow?",
        "Are you able to speak Japanese?",
      ],
    },
  };

  const currentQuestion = questions[currentQuestionIndex];

  useEffect(() => {
    let timer;
    if (isTimerRunning && timeLeft > 0) {
      timer = setInterval(() => {
        setTimeLeft((prevTime) => {
          if (prevTime <= 1) {
            setIsTimerRunning(false);
            return 0;
          }
          return prevTime - 1;
        });
      }, 1000);
    }
    return () => clearInterval(timer);
  }, [isTimerRunning, timeLeft]);

  const handleStart = () => {
    setIsStarted(true);
    setTimeLeft(0);
    setIsTimerRunning(false);
  };

  const handleAnswer = (choice) => {
    setSelectedAnswers((prev) => {
      // 이미 선택된 경우 제거
      if (prev.includes(choice)) {
        return prev.filter((item) => item !== choice);
      }
      // 2개까지만 선택 가능
      if (prev.length >= 2) {
        return prev;
      }
      // 새로운 선택 추가
      return [...prev, choice];
    });
  };

  // currentUser 상태 확인을 위한 useEffect 추가
  useEffect(() => {
    if (currentUser) {
      // 사용자 로그인 상태 확인
    }
  }, [currentUser]);

  // 틀린 문제 저장 함수 최적화
  const saveWrongAnswer = async (questionNumber) => {
    if (!currentUser) return;

    try {
      const userDocRef = doc(db, "users", currentUser.uid);
      const path = `part2.${selectedSubCategory}.wrongQuestions`;

      await updateDoc(userDocRef, {
        [path]: arrayUnion(questionNumber),
      });
    } catch (error) {
      console.error("틀린 문제 저장 중 오류:", error);
    }
  };

  // 틀린 문제 제거 함수
  const removeFromWrongQuestions = async (questionNumber) => {
    if (!currentUser) return;

    try {
      const wrongQuestionsRef = doc(db, "wrongQuestions", currentUser.uid);
      const path = `part2/${selectedSubCategory}`;

      // 현재 틀린 문제 목록 가져오기
      const wrongQuestionsDoc = await getDoc(wrongQuestionsRef);
      const currentWrongQuestions = wrongQuestionsDoc.data()?.[path] || [];

      // 맞춘 문제 번호 제거
      const updatedWrongQuestions = currentWrongQuestions.filter(
        (num) => num !== questionNumber
      );

      // 업데이트된 목록 저장
      await setDoc(
        wrongQuestionsRef,
        {
          [path]: updatedWrongQuestions,
        },
        { merge: true }
      );
    } catch (error) {
      console.error("틀린 문제 제거 중 오류:", error);
    }
  };

  // 답 확인 핸들러 수정
  const handleCheckAnswer = async () => {
    if (isChecking) return;

    try {
      setIsChecking(true);

      const currentQuestion = questions[currentQuestionIndex];
      const isCorrect =
        selectedAnswers.length === 2 &&
        selectedAnswers.sort().join("") ===
          currentQuestion.incorrectAnswers.sort().join("");

      // 답을 체크했을 때 푼 문제 목록에 추가
      setSolvedQuestions(
        (prev) => new Set([...prev, currentQuestion.questionNumber])
      );

      setShowResult(true);
      setIsTimerRunning(false);

      // 마지막 위치 저장
      if (currentUser) {
        saveLastQuestionIndex();
      }

      if (audioRef.current) {
        audioRef.current.pause();
        audioRef.current.currentTime = 0;
      }

      if (selectedAnswers.length === 2) {
        if (!isCorrect) {
          await saveWrongAnswer(currentQuestion.questionNumber);
        } else {
          await removeFromWrongQuestions(currentQuestion.questionNumber);
        }
      }
    } catch (error) {
      console.error("답 확인 중 오류:", error);
    } finally {
      setIsChecking(false);
    }
  };

  // 답 확인 버튼 컴포넌트 수정
  const renderCheckButton = () => {
    return (
      <button
        onClick={handleCheckAnswer}
        disabled={isChecking}
        className={`check-answer-btn ${isChecking ? "checking" : ""}`}
      >
        {isChecking ? "확인 중..." : "답 확인하기"}
      </button>
    );
  };

  const handleNext = () => {
    if (currentQuestionIndex === questions.length - 1) {
      alert("모든 문제를 완료했습니다! 🎉");
      setShowQuestions(false);
      setSelectedCategory("");
      setCurrentQuestionIndex(0);
      setIsStarted(false);
      setSelectedAnswers([]);
      return;
    }

    // 상태 초기화
    setShowResult(false);
    setSelectedAnswers([]);
    setTimeLeft(studyMode === "text" ? 10 : 0);
    setIsTimerRunning(studyMode === "text");
    setIsPlaying(false);
    setIsChecking(false);

    const nextIndex = currentQuestionIndex + 1;
    setCurrentQuestionIndex(nextIndex);

    // 마지막 위치 저장
    if (currentUser) {
      saveLastQuestionIndex();
    }

    // 오디오 초기화
    if (audioRef.current) {
      audioRef.current.pause();
      audioRef.current.currentTime = 0;
    }
  };

  const playAudio = () => {
    if (!currentQuestion) return;

    if (isPlaying) {
      if (audioRef.current) {
        audioRef.current.pause();
        setIsPlaying(false);
      }
      return;
    }

    let audioPath;

    // why 카테고리의 1번 문제인 경우에만 특별 파일명 사용
    if (selectedSubCategory === "why" && currentQuestion.questionNumber === 1) {
      audioPath = `${process.env.PUBLIC_URL}/audios/part2/why/${accentType}/whyuus1.mp3`;
    } else {
      // 다른 모든 파일은 기존 방식 사용
      audioPath = `${process.env.PUBLIC_URL}/audios/part2/${selectedSubCategory}/${accentType}/${selectedSubCategory}${currentQuestion.questionNumber}.mp3`;
    }

    // 오디오 경로 콘솔에 출력
    console.log("재생 중인 오디오 경로:", audioPath);

    if (audioRef.current) {
      if (audioRef.current.src !== audioPath) {
        audioRef.current.src = audioPath;
      }
      audioRef.current.playbackRate = playbackRate;
      audioRef.current
        .play()
        .then(() => {
          setIsPlaying(true);
        })
        .catch((error) => {
          console.error("오디오 재생 실패:", error, "경로:", audioPath);
          setIsPlaying(false);
        });
    }
  };

  const handleAudioEnd = () => {
    setIsPlaying(false);
  };

  const handlePlaybackRateChange = (rate) => {
    setPlaybackRate(rate);
    if (audioRef.current) {
      audioRef.current.playbackRate = rate;
    }
  };

  const getMarkedText = (text) => {
    const parser = new DOMParser();
    const doc = parser.parseFromString(text, "text/html");
    const marks = doc.getElementsByTagName("mark");
    if (marks.length > 0) {
      return marks[0].textContent;
    }
    return text;
  };

  const renderQuestion = () => {
    if (questions.length === 0) return null;

    // 현재 인덱스가 배열 범위를 벗어났는지 확인
    if (currentQuestionIndex >= questions.length) {
      // 범위를 벗어났다면 0으로 리셋
      setCurrentQuestionIndex(0);
      return null; // 리렌더링될 때까지 아무것도 표시하지 않음
    }

    const currentQuestion = questions[currentQuestionIndex];

    const handleBackToCategories = () => {
      setShowQuestions(false);
      setSelectedCategory("");
      setCurrentQuestionIndex(0);
      setIsStarted(false);
      setSelectedAnswers([]);
      setShowResult(false);
      if (audioRef.current) {
        audioRef.current.pause();
        audioRef.current.currentTime = 0;
      }
    };

    const handleRestartFromBeginning = () => {
      // 현재 카테고리는 유지하고 첫 문제부터 다시 시작
      setCurrentQuestionIndex(0);
      setShowResult(false);
      setSelectedAnswers([]);
      setTimeLeft(studyMode === "text" ? 10 : 0);
      setIsTimerRunning(studyMode === "text");
      setIsPlaying(false);
      setIsChecking(false);
      setSolvedQuestions(new Set());

      // 저장된 인덱스 초기화
      if (currentUser && selectedSubCategory) {
        const userDocRef = doc(db, "users", currentUser.uid);
        updateDoc(userDocRef, {
          [`part2LastQuestionIndices.${selectedSubCategory}`]: 0,
        }).catch((error) => {
          console.error("인덱스 초기화 중 오류:", error);
        });
      }

      // 오디오 초기화
      if (audioRef.current) {
        audioRef.current.pause();
        audioRef.current.currentTime = 0;
      }
    };

    return (
      <div className="question-container">
        <div
          className="navigation-buttons"
          style={{
            display: "flex",
            justifyContent: "flex-start",
            width: "100%",
            gap: "10px",
          }}
        >
          <button
            className="back-to-categories-btn"
            onClick={handleBackToCategories}
          >
            ◀ 유형 선택으로
          </button>
          <button className="restart-btn" onClick={handleRestartFromBeginning}>
            처음부터 다시풀기
          </button>
          <button
            className="video-btn"
            style={{
              backgroundColor: "#4a4a7a",
              color: "white",
              border: "none",
              borderRadius: "4px",
              padding: "8px 16px",
              cursor: "pointer",
            }}
            onClick={() => setShowVideoModal(true)}
          >
            설명 동영상
          </button>
        </div>

        {studyMode !== "audio" && (
          <div className="question-text">
            <div style={{ marginLeft: "20px" }}>
              {currentQuestion.questionText.replace(/<\/?mark>/g, "")}
            </div>
            <div className="part2-progress-info">
              ({currentQuestionIndex + 1} / {questions.length})
            </div>
          </div>
        )}

        {studyMode !== "text" && (
          <div className="audio-controls">
            <div className="accent-selector">
              <button
                className={`accent-btn ${accentType === "us" ? "active" : ""}`}
                onClick={() => {
                  setAccentType("us");
                  // 오디오 재생 중지 및 초기화
                  if (audioRef.current) {
                    audioRef.current.pause();
                    audioRef.current.currentTime = 0;
                  }
                  setIsPlaying(false);
                }}
              >
                미국발음
              </button>
              <button
                className={`accent-btn ${accentType === "uk" ? "active" : ""}`}
                onClick={() => {
                  setAccentType("uk");
                  // 오디오 재생 중지 및 초기화
                  if (audioRef.current) {
                    audioRef.current.pause();
                    audioRef.current.currentTime = 0;
                  }
                  setIsPlaying(false);
                }}
              >
                영국발음
              </button>
            </div>

            <div className="playback-controls">
              {[0.5, 1.0, 1.5, 2.0].map((rate) => (
                <button
                  key={rate}
                  className={`playback-btn ${
                    playbackRate === rate ? "active" : ""
                  }`}
                  onClick={() => handlePlaybackRateChange(rate)}
                >
                  {rate}x
                </button>
              ))}
            </div>

            <button
              className={`play-btn ${isPlaying ? "playing" : ""}`}
              onClick={playAudio}
            >
              <img
                src={`/icons/${isPlaying ? "stop" : "play"}.svg`}
                alt={isPlaying ? "정지" : "재생"}
                className="play-icon"
              />
              {isPlaying ? "정지" : "음성 듣기"}
            </button>
          </div>
        )}

        <div className="question-instruction">틀린 보기 2개를 선택하세요.</div>

        <div className="choices-container">
          {["A", "B", "C"].map((choice) => (
            <button
              key={choice}
              className={`choice-btn ${
                selectedAnswers.includes(choice) ? "selected" : ""
              } ${
                showResult
                  ? currentQuestion.incorrectAnswers.includes(choice)
                    ? "wrong"
                    : "correct"
                  : ""
              }`}
              onClick={() => handleAnswer(choice)}
              disabled={
                showResult ||
                (!selectedAnswers.includes(choice) &&
                  selectedAnswers.length >= 2)
              }
            >
              {choice}
              {studyMode !== "audio" && `. ${currentQuestion.choices[choice]}`}
            </button>
          ))}
        </div>

        {!showResult && (
          <div className="check-answer-container">{renderCheckButton()}</div>
        )}

        {showResult && (
          <div className="navigation-buttons">
            <button
              className="nav-button"
              onClick={() => {
                setCurrentQuestionIndex((prev) => prev - 1);
                setShowResult(false);
                setSelectedAnswers([]);
                setTimeLeft(studyMode === "text" ? 10 : 0);
                setIsTimerRunning(studyMode === "text");
                setIsPlaying(false);
                setIsChecking(false);
                if (audioRef.current) {
                  audioRef.current.pause();
                  audioRef.current.currentTime = 0;
                }
              }}
              disabled={currentQuestionIndex === 0}
            >
              이전
            </button>

            <button
              className={`nav-button ${
                solvedQuestions.size === questions.length ||
                currentQuestionIndex === questions.length - 1
                  ? "complete-button"
                  : ""
              }`}
              onClick={() => {
                if (
                  solvedQuestions.size === questions.length ||
                  currentQuestionIndex === questions.length - 1
                ) {
                  handleComplete();
                } else {
                  setCurrentQuestionIndex((prev) => prev + 1);
                  setShowResult(false);
                  setSelectedAnswers([]);
                  setTimeLeft(studyMode === "text" ? 10 : 0);
                  setIsTimerRunning(studyMode === "text");
                  setIsPlaying(false);
                  setIsChecking(false);
                  if (audioRef.current) {
                    audioRef.current.pause();
                    audioRef.current.currentTime = 0;
                  }
                }
              }}
              disabled={
                currentQuestionIndex === questions.length - 1 &&
                !solvedQuestions.has(
                  questions[currentQuestionIndex]?.questionNumber
                )
              }
            >
              {solvedQuestions.size === questions.length ||
              currentQuestionIndex === questions.length - 1
                ? "학습 완료"
                : "다음"}
            </button>
          </div>
        )}

        {showResult && (
          <div className="result-container">
            <div
              className={`result-message ${
                selectedAnswers.sort().join("") ===
                currentQuestion.incorrectAnswers.sort().join("")
                  ? "correct"
                  : "incorrect"
              }`}
            >
              {selectedAnswers.sort().join("") ===
              currentQuestion.incorrectAnswers.sort().join("")
                ? "틀린것 2개를 모두 잘 골랐습니다! "
                : "틀렸습니다. 틀린 답은 " +
                  currentQuestion.incorrectAnswers.join(", ") +
                  "번입니다."}
            </div>

            <div className="explanation-container">
              <h4>📝 문제 해설</h4>
              <div className="question-translation">
                Q. {currentQuestion.translation.question}
              </div>
              <div className="choices-translation">
                A. {currentQuestion.choices.A} (
                {currentQuestion.translation.choices.A})<br />
                B. {currentQuestion.choices.B} (
                {currentQuestion.translation.choices.B})<br />
                C. {currentQuestion.choices.C} (
                {currentQuestion.translation.choices.C})
              </div>
              <div className="explanation-text">
                {currentQuestion.explanation || ""}
              </div>
            </div>
          </div>
        )}
      </div>
    );
  };

  const fetchQuestions = async () => {
    if (!selectedSubCategory) return;

    try {
      const questionsRef = collection(
        db,
        "part2",
        selectedSubCategory,
        "questions"
      );
      const q = query(questionsRef, orderBy("questionNumber", "asc"));
      const querySnapshot = await getDocs(q);

      const fetchedQuestions = querySnapshot.docs.map((doc) => {
        const data = doc.data();
        const questionNum = parseInt(data.questionNumber, 10);

        return {
          id: doc.id,
          ...data,
          questionNumber: questionNum,
          audioUrl: `/audios/part2/${selectedSubCategory}/${questionNum}.mp3`,
        };
      });

      setQuestions(fetchedQuestions);
      setLoading(false);
    } catch (error) {
      console.error("Error fetching questions:", error);
      setLoading(false);
    }
  };

  useEffect(() => {
    const questionMap = {
      who: whoQuestions,
      where: whereQuestions,
      which: whichQuestions,
      why: whyQuestions,
      what: whatQuestions,
      when: whenQuestions,
      how: howQuestions,
      auxiliary: auxiliaryQuestions,
      tag: tagQuestions,
      nounClause: nounClauseQuestions,
      beVerb: beVerbQuestions,
      makeChoice: makeChoiceQuestions,
      negative: negativeQuestions,
      state: stateQuestions,
      abilityPossibilityAuxiliary: abilityPossibilityAuxiliaryQuestions,
    };

    if (selectedSubCategory) {
      // 문제 데이터 준비
      let questionsWithAudio = questionMap[selectedSubCategory].map((q) => ({
        ...q,
        audioUrl: `/audios/part2/${selectedSubCategory}/${accentType}/${selectedSubCategory}${q.questionNumber}.mp3`,
      }));

      setQuestions(questionsWithAudio);
      setLoading(false);
    }
  }, [selectedSubCategory, accentType]);

  useEffect(() => {
    // 완료된 카테고리 불러오기
    const loadCompletedCategories = async () => {
      if (!currentUser) return;

      const userRef = doc(db, "users", currentUser.uid);
      const userDoc = await getDoc(userRef);

      if (userDoc.exists()) {
        const data = userDoc.data();
        setCompletedCategories(data.part2CompletedCategories || {});
      }
    };

    loadCompletedCategories();
  }, [currentUser]);

  const handleComplete = async () => {
    if (!currentUser) return;

    try {
      const updatedCategories = {
        ...completedCategories,
        [selectedSubCategory]: true,
      };

      // Firestore에 저장
      const userRef = doc(db, "users", currentUser.uid);
      await setDoc(
        userRef,
        {
          part2CompletedCategories: updatedCategories,
        },
        { merge: true }
      );

      setCompletedCategories(updatedCategories);
      setShowQuestions(false);
      setSelectedSubCategory("");
    } catch (error) {
      console.error("학습 완료 처리 중 오류:", error);
    }
  };

  // useEffect 추가 - 컴포넌트 마운트 시 마지막 문제 인덱스 불러오기
  useEffect(() => {
    if (currentUser) {
      loadLastQuestionIndices();
    }
  }, [currentUser]);

  // 마지막 문제 인덱스 저장 함수
  const saveLastQuestionIndex = async () => {
    if (!currentUser || !selectedSubCategory) return;

    try {
      console.log(
        "마지막 인덱스 저장:",
        selectedSubCategory,
        currentQuestionIndex
      );
      const userDocRef = doc(db, "users", currentUser.uid);

      // 기존 데이터를 가져와서 업데이트
      const userDoc = await getDoc(userDocRef);
      let updatedIndices = {};

      if (userDoc.exists()) {
        const data = userDoc.data();
        updatedIndices = data.part2LastQuestionIndices || {};
      }

      // 현재 카테고리의 인덱스 업데이트
      updatedIndices[selectedSubCategory] = currentQuestionIndex;

      // 전체 객체를 한 번에 업데이트
      await setDoc(
        userDocRef,
        {
          part2LastQuestionIndices: updatedIndices,
        },
        { merge: true }
      );

      // 로컬 상태 업데이트
      setLastQuestionIndices(updatedIndices);
      console.log("마지막 인덱스 저장 완료:", updatedIndices);
      await updateDoc(userDocRef, {
        [`part2LastQuestionIndices.${selectedSubCategory}`]:
          currentQuestionIndex,
      });
    } catch (error) {
      console.error("마지막 문제 인덱스 저장 중 오류:", error);
    }
  };

  // 마지막 문제 인덱스 불러오는 함수
  const loadLastQuestionIndices = async () => {
    if (!currentUser) return;

    try {
      const userDocRef = doc(db, "users", currentUser.uid);
      const userDoc = await getDoc(userDocRef);

      if (userDoc.exists()) {
        const data = userDoc.data();
        if (data.part2LastQuestionIndices) {
          setLastQuestionIndices(data.part2LastQuestionIndices);
        }
      }
    } catch (error) {
      console.error("마지막 문제 인덱스 로드 중 오류:", error);
    }
  };

  // studyMode 선택 함수 수정
  const handleStudyModeSelect = async (mode) => {
    setSolvedQuestions(new Set());
    try {
      if (mode === "wrong") {
        const userDocRef = doc(db, "users", currentUser.uid);
        const userDoc = await getDoc(userDocRef);
        const data = userDoc.data();
        const wrongQuestions =
          data?.part2?.[selectedSubCategory]?.wrongQuestions || [];

        if (wrongQuestions.length === 0) {
          setShowNoWrongQuestionsModal(true);
          setIsStudyModeModalOpen(false);
          return;
        }

        // 틀린 문제만 필터링
        const filteredQuestions = questions.filter((q) =>
          wrongQuestions.includes(q.questionNumber)
        );

        setQuestions(filteredQuestions);
        setStudyMode("both");
        setCurrentQuestionIndex(0);
      } else if (mode === "all") {
        // 전체 문제 모드에서 마지막 풀이 위치부터 시작
        const lastIndex = lastQuestionIndices[selectedSubCategory] || 0;

        // 여기에 안전 검사 추가
        if (lastIndex >= questions.length) {
          // 인덱스가 범위를 벗어나면 0부터 다시 시작
          setCurrentQuestionIndex(0);

          // Firestore에도 업데이트
          if (currentUser) {
            const userDocRef = doc(db, "users", currentUser.uid);
            await updateDoc(userDocRef, {
              [`part2LastQuestionIndices.${selectedSubCategory}`]: 0,
            });
          }
        } else {
          setCurrentQuestionIndex(lastIndex);
        }

        setStudyMode("both");
        setShowResult(false);
        setSelectedAnswers([]);
      } else {
        setStudyMode(mode);
      }

      setIsStudyModeModalOpen(false);
      setShowQuestions(true);
      setIsStarted(true);
      setTimeLeft(mode === "text" ? 10 : 0);
      setIsTimerRunning(mode === "text");
      setShowResult(false);
      setSelectedAnswers([]);
    } catch (error) {
      console.error("학습 모드 설정 중 오류:", error);
      setIsStudyModeModalOpen(false);
    }
  };

  // handleCategoryClick 함수 수정
  const handleCategoryClick = (categoryKey) => {
    // 무료 컨텐츠인지 확인
    const isFreeContent =
      isActive || freeContent.part2.questions.includes(categoryKey);

    // 유료 컨텐츠이고 구독하지 않은 경우 모달 표시하지 않고 return
    if (!isFreeContent) {
      return;
    }

    // 무료 컨텐츠이거나 구독자인 경우에만 실행
    setSelectedSubCategory(categoryKey);
    setIsStudyModeModalOpen(true);
  };

  const renderSubCategorySelection = () => {
    return (
      <div className="subcategory-selection">
        <h2>TOEIC Part 2 - 응답하기</h2>
        <div className="subcategory-grid">
          {Object.entries(subCategories).map(([key, category]) => {
            // isActive가 true면 모든 콘텐츠를 이용 가능하도록 설정
            const isFreeContent =
              isActive || freeContent.part2.questions.includes(key);

            return (
              <div
                key={key}
                className={`subcategory-card ${
                  !isFreeContent ? "premium" : ""
                }`}
                onClick={() => handleCategoryClick(key)}
                style={{ cursor: "pointer" }}
              >
                <h3>{category.title}</h3>
                <p>{category.description}</p>
                {/* isActive가 true면 잠금 아이콘을 표시하지 않음 */}
                {!isFreeContent && !isActive && (
                  <div className="lock-overlay">
                    <img src="/icons/lock.svg" alt="잠김" />
                  </div>
                )}
                {completedCategories[key] && (
                  <div className="completion-badge">학습완료</div>
                )}
              </div>
            );
          })}
        </div>
      </div>
    );
  };

  const handleStudyModeChange = (newMode) => {
    setStudyMode(newMode);

    // 현재 문제의 상태만 초기화
    setSelectedAnswers([]);
    setShowResult(false);
    setTimeLeft(newMode === "text" ? 10 : 0);
    setIsTimerRunning(false);

    // 오디오 초기화
    if (audioRef.current) {
      audioRef.current.pause();
      audioRef.current.currentTime = 0;
    }
  };

  // 정답을 계산하는 함수 추가
  const getCorrectAnswer = (question) => {
    if (!question) return "";

    // A, B, C 중에서 incorrectAnswers에 포함되지 않은 것이 정답
    const choices = ["A", "B", "C"];
    return choices.find(
      (choice) => !question.incorrectAnswers.includes(choice)
    );
  };

  // 선택한 답이 맞았는지 확인하는 로직도 수정
  const isCorrectAnswer = (selectedAnswer, question) => {
    if (!question) return false;
    return selectedAnswer === getCorrectAnswer(question);
  };

  const handleWrongQuestionMode = async () => {
    if (!currentUser) return;

    try {
      const userDocRef = doc(db, "users", currentUser.uid);
      const userDoc = await getDoc(userDocRef);

      const data = userDoc.data();
      const wrongQuestions =
        data?.part2?.[selectedSubCategory]?.wrongQuestions || [];

      if (wrongQuestions && wrongQuestions.length > 0) {
        setStudyMode("wrong");
        setIsStudyModeModalOpen(false);
        setShowQuestions(true);
      } else {
        setIsStudyModeModalOpen(false);
        setShowNoWrongQuestionsModal(true);
      }
    } catch (error) {
      console.error("틀린 문제 확인 중 오류:", error);
      setIsStudyModeModalOpen(false);
    }
  };

  // 카테고리나 학습 모드 변경 시 초기화 추가
  useEffect(() => {
    setSolvedQuestions(new Set());
  }, [selectedSubCategory]);

  return (
    <div className="part2-container">
      <audio
        ref={audioRef}
        onEnded={handleAudioEnd}
        onError={(e) => console.error("오디오 로드 에러:", e.target.error)}
        preload="auto"
      />

      {showVocabModal && (
        <Part2VocabModal onClose={() => setShowVocabModal(false)} />
      )}

      {!showQuestions ? (
        renderSubCategorySelection()
      ) : (
        <>
          <div className="part2-study-options">
            <div className="study-options-header">
              <span className="study-options-title">학습 단계</span>
            </div>
            <div className="study-options-buttons">
              <button
                className={`part2-option-btn ${
                  studyMode === "both" ? "active" : ""
                }`}
                onClick={() => handleStudyModeChange("both")}
              >
                1단계: 텍스트+오디오
              </button>
              <span className="arrow-icon">→</span>
              <button
                className={`part2-option-btn ${
                  studyMode === "audio" ? "active" : ""
                }`}
                onClick={() => handleStudyModeChange("audio")}
              >
                2단계: 오디오만
              </button>
            </div>
            <div className="study-mode-description">
              {studyMode === "both" && (
                <p>
                  우선 텍스트를 보며 오답 2개를 골라보세요. 그리고 음성 파일을
                  들어보며 텍스트가 어떻게 들리는지를 파악합니다. 오답 2개는
                  확실한 오답으로 구성됩니다. 항상 들으며 아닌 것 2개를 고르는
                  습관을 만들어보세요. 실전에서는 맞는걸 골라야 합니다. 그러나
                  훈련부터 틀린것을 없애는 소거법으로 풀도록 훈련합니다. 맞는걸
                  고르려고 하면 더 어렵습니다. 토익에선 어느정도 확실한 오답을
                  보기에 배치하기에 아닌걸 고르는 훈련을 미리 하고 실제
                  시험보실땐 틀린걸 제거하고 남은걸 마킹하세요
                </p>
              )}
              {studyMode === "audio" && (
                <p>
                  텍스트 없이 오디오만 듣고도 내가 텍스트에서 이해한 내용이
                  들어서도 이해되는지만 파악합니다. 여전히 오답지문들이 질문과
                  맞지 않게 들리는지 체크합니다. 미국발음과 영국발음을
                  시도해보고 속도를 높여가며 들으면 더 효과가
                  좋습니다..실전에서는 맞는걸 골라야 합니다. 그러나 훈련부터
                  틀린것을 없애는 소거법으로 풀도록 훈련합니다. 맞는걸 고르려고
                  하면 더 어렵습니다. 토익에선 어느정도 확실한 오답을 보기에
                  배치하기에 아닌걸 고르는 훈련을 미리 하고 실제 시험보실땐
                  틀린걸 제거하고 남은걸 마킹하세요
                </p>
              )}
            </div>
          </div>
          {renderQuestion()}
        </>
      )}

      <Modal
        isOpen={showNoWrongQuestionsModal}
        onRequestClose={() => setShowNoWrongQuestionsModal(false)}
        className="no-wrong-questions-modal"
        overlayClassName="no-wrong-questions-overlay"
      >
        <div className="text-center p-8">
          <h2 className="text-2xl font-bold mb-4">📚 알림</h2>
          <p className="text-gray-600 mb-6">
            현재 틀린 문제가 없습니다!
            <br />
            전체 문제 풀이를 진행해주세요.
          </p>
          <button
            onClick={() => setShowNoWrongQuestionsModal(false)}
            className="modal-button"
          >
            확인
          </button>
        </div>
      </Modal>

      <Modal
        isOpen={isStudyModeModalOpen}
        onRequestClose={() => setIsStudyModeModalOpen(false)}
        className="study-mode-modal-content"
        overlayClassName="study-mode-modal-overlay"
      >
        <div className="study-mode-modal-header">
          <h3>학습 모드 선택</h3>
          <button
            className="modal-close-btn"
            onClick={() => setIsStudyModeModalOpen(false)}
          >
            ✕
          </button>
        </div>
        <div className="study-mode-options">
          <button
            className="study-mode-button all"
            onClick={() => handleStudyModeSelect("all")}
          >
            전체 문제 풀기
          </button>
          <button
            className="study-mode-button wrong"
            onClick={() => handleStudyModeSelect("wrong")}
            disabled={!currentUser}
          >
            틀린 문제만 풀기
            {!currentUser && (
              <span className="login-required">(로그인 필요)</span>
            )}
          </button>
        </div>
      </Modal>

      {showVideoModal && (
        <div
          style={{
            position: "fixed",
            top: 0,
            left: 0,
            right: 0,
            bottom: 0,
            backgroundColor: "rgba(0, 0, 0, 0.8)",
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            zIndex: 1100,
          }}
          onClick={() => setShowVideoModal(false)}
        >
          <div
            style={{
              background: "#222",
              borderRadius: "8px",
              padding: "20px",
              width: "90%",
              maxWidth: "800px",
              position: "relative",
            }}
            onClick={(e) => e.stopPropagation()}
          >
            <button
              style={{
                position: "absolute",
                top: "10px",
                right: "10px",
                background: "none",
                border: "none",
                color: "white",
                fontSize: "24px",
                cursor: "pointer",
              }}
              onClick={() => setShowVideoModal(false)}
            >
              ×
            </button>
            <video
              src="/videos/part2-explanation.mp4"
              controls
              autoPlay
              style={{ width: "100%", marginTop: "20px" }}
            />
          </div>
        </div>
      )}
    </div>
  );
};

export default Part2_1;
